import { getMetricDisplayName } from '@src/utils/metrics/metricHelpers';
import { getLocalTime } from '@store/aiAlerts/summary/helper';

export const sensitivityLogColumns = [
  {
    title: 'User',
    width: 100,
    flexGrow: 1,
    resizable: true,
    dataKey: 'user',
    key: 'user',
  },
  {
    title: 'Date',
    width: 0,
    flexGrow: 1,
    resizable: true,
    dataKey: 'date',
    key: 'date',
  },
  {
    title: 'Metric',
    width: 0,
    flexGrow: 1,
    resizable: true,
    dataKey: 'metric',
    key: 'metric',
  },
  {
    title: 'Persistence',
    width: 0,
    flexGrow: 1,
    resizable: true,
    dataKey: 'sustain',
    key: 'sustain',
    cellRenderer: (data: any) => (data.cellData ? `${data.cellData} mins` : 'None'),
  },
  {
    title: 'Impacted Unique',
    width: 0,
    flexGrow: 1,
    resizable: true,
    dataKey: 'impactedUnique',
    key: 'impactedUnique',
    cellRenderer: (data: any) => getCellDataBasedOnMetric(data),
  },
  {
    title: 'Pcp Drop',
    width: 0,
    flexGrow: 1,
    resizable: true,
    dataKey: 'sustainPcpDrop',
    key: 'sustainPcpDrop',
    cellRenderer: (data: any) => getPCPDropDataBasedOnMetric(data),
  },
  {
    title: 'Impacted Unique Pct',
    width: 0,
    flexGrow: 1,
    resizable: true,
    dataKey: 'impactedUniquePct',
    key: 'impactedUniquePct',
    cellRenderer: (data: any) => getCellDataBasedOnMetric(data),
  },
  {
    title: 'Warning Persistence',
    width: 0,
    flexGrow: 1,
    resizable: true,
    dataKey: 'warningSustain',
    key: 'warningSustain',
    cellRenderer: (data: any) => (data.cellData ? `${data.cellData} mins` : 'None'),
  },
  {
    title: 'Warning Impacted Unique',
    width: 0,
    flexGrow: 1,
    resizable: true,
    dataKey: 'warningImpactedUnique',
    key: 'warningImpactedUnique',
    cellRenderer: (data: any) => getCellDataBasedOnMetric(data),
  },
  {
    title: 'Warning Unique pct',
    width: 0,
    flexGrow: 1,
    resizable: true,
    dataKey: 'warningImpactedUniquePct',
    key: 'warningImpactedUniquePct',
    cellRenderer: (data: any) => getCellDataBasedOnMetric(data),
  },
  {
    title: 'Warning Pcp Drop',
    width: 0,
    flexGrow: 1,
    resizable: true,
    dataKey: 'warningPcpDrop',
    key: 'warningPcpDrop',
    cellRenderer: (data: any) => getPCPDropDataBasedOnMetric(data),
  },
  {
    title: 'Critical Persistence',
    width: 0,
    flexGrow: 1,
    resizable: true,
    dataKey: 'criticalSustain',
    key: 'criticalSustain',
    cellRenderer: (data: any) => (data.cellData ? `${data.cellData} mins` : 'None'),
  },
  {
    title: 'Critical Impacted Unique',
    width: 0,
    flexGrow: 1,
    resizable: true,
    dataKey: 'criticalImpactedUnique',
    key: 'criticalImpactedUnique',
    cellRenderer: (data: any) => getCellDataBasedOnMetric(data),
  },
  {
    title: 'Critical Unique pct',
    width: 0,
    flexGrow: 1,
    resizable: true,
    dataKey: 'criticalImpactedUniquePct',
    key: 'criticalImpactedUniquePct',
    cellRenderer: (data: any) => getCellDataBasedOnMetric(data),
  },
  {
    title: 'Critical PCP Drop',
    width: 0,
    flexGrow: 1,
    resizable: true,
    dataKey: 'criticalPcpDrop',
    key: 'criticalPcpDrop',
    cellRenderer: (data: any) => getPCPDropDataBasedOnMetric(data),
  },
];

const getAdAlertValueWithUnit = (data) => {
  const { metric } = data.rowData;
  if (metric === 'Ad Average Bitrate') {
    return `${data.cellData} mbps`;
  }
  return `${data.cellData} %`;
};

export const sensitivityAdAlertLogColumns = [
  {
    title: 'User',
    width: 100,
    flexGrow: 1,
    resizable: true,
    dataKey: 'user',
    key: 'user',
  },
  {
    title: 'Date',
    width: 0,
    flexGrow: 1,
    resizable: true,
    dataKey: 'date',
    key: 'date',
  },
  {
    title: 'Metric',
    width: 0,
    flexGrow: 1,
    resizable: true,
    dataKey: 'metric',
    key: 'metric',
    cellRenderer: (data: any) =>
      data.cellData
        ? getMetricDisplayName({ metricKey: data.cellData, context: 'EI' })
        : data.cellData,
  },
  {
    title: 'Threshold',
    width: 0,
    flexGrow: 1,
    resizable: true,
    dataKey: 'asf',
    key: 'asf',
    cellRenderer: (data: any) => (data.cellData ? getAdAlertValueWithUnit(data) : 'None'),
  },
  {
    title: 'Cumulative Impacted Unique Devices',
    width: 0,
    flexGrow: 1,
    resizable: true,
    dataKey: 'impactedUnique',
    key: 'impactedUnique',
    cellRenderer: (data: any) => (data.cellData ? data.cellData : 'None'),
  },
];

const getPCPDropDataBasedOnMetric = (data) => {
  if (!['APP_ACTIVE_DEVICES', 'AUTOALERTPCP'].includes(data.rowData?.metricKey)) {
    return 'NA';
  }
  return data.cellData ? data.cellData : 'None';
};

const getCellDataBasedOnMetric = (data) => {
  if (['APP_ACTIVE_DEVICES', 'AUTOALERTPCP'].includes(data.rowData?.metricKey)) {
    return 'NA';
  }
  return data.cellData ? data.cellData : 'None';
};

const formatColumnData = (filteredLogs) => {
  return filteredLogs.map((log) => {
    return {
      ...log,
      metricKey: log.metricKey,
      metric: log.metric,
      date: getLocalTime(log.updatedAt, null),
    };
  });
};

export const getDataForColumns = (logsData) => {
  const filteredLogs = logsData.filter((log) => log.app === 'ei');
  const formatted = formatColumnData(filteredLogs);
  return formatted.reverse();
};

export const getDataForAppColumns = (logsData) => {
  const filteredLogs = logsData.filter((log) => log.app === 'ae');
  const formatted = formatColumnData(filteredLogs);
  return formatted.reverse();
};

export const getDataForAdColumns = (logsData) => {
  const filteredLogs = logsData.filter((log) => log.app === 'ai');
  const formatted = formatColumnData(filteredLogs);
  return formatted.reverse();
};

export const defaultSort = { key: 'eventTime', order: 'desc' };
